import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SectionHeading from "@/components/SectionHeading";
import Gallery from "@/components/Gallery";
import HeroSection from "@/components/HeroSection";

const VidezBetonaKamna = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <HeroSection
          title="Keramične ploščice videz betona, kamna"
          subtitle="Moderen in robusten dizajn"
          imageSrc="/placeholder.svg"
          primaryButtonText="Zahtevaj ponudbo"
          primaryButtonLink="/kontakt"
        />
        
        <div className="container-custom mx-auto py-16">
          <SectionHeading
            title="Videz betona, kamna"
            subtitle="Moderen in robusten dizajn"
          />
          
          <div className="mt-8 prose prose-lg max-w-none">
            <p>
              Keramične ploščice z videzom betona ali kamna predstavljajo sodobno estetiko z industrijskim pridihom.
              Idealne so za moderne, minimalistične prostore, ki potrebujejo trpežno in enostavno vzdrževano talno oblogo.
            </p>
          </div>
          
          <Gallery
            images={[
              { src: "/placeholder.svg", alt: "Beton/kamen ploščice 1" },
              { src: "/placeholder.svg", alt: "Beton/kamen ploščice 2" },
              { src: "/placeholder.svg", alt: "Beton/kamen ploščice 3" },
              { src: "/placeholder.svg", alt: "Beton/kamen ploščice 4" },
            ]}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default VidezBetonaKamna;